module.exports = __webpack_public_path__ + "static/media/undraw_Taken.d822e335.svg";